import { withModalContext } from '@jutro/components';
import { TranslatorContext } from '@jutro/locale';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { withDependencies } from '@xengage/gw-portals-dependency-react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import DocumentComponent from '../../components/DocumentsComponent/DocumentsComponent';
import documentMessages from '../../Document.messages';
import messages from './DocumentsPage.messages';
import metadata from './DocumentsPage.metadata.json5';
import DocumentUploadComponent from '../../components/DocumentUpload/DocumentUploadComponent';

const DOCUMENTS_KEY = 'Documents';

class DocumentsPage extends Component {
    static propTypes = {
        DocumentPageService: PropTypes.shape({
            generateUploadToken: PropTypes.func,
            uploadDocument: PropTypes.func,
            getDocuments: PropTypes.func,
            removeDocument: PropTypes.func,
            downloadDocument: PropTypes.func,
        }).isRequired,
        authHeader: PropTypes.shape({
            Authorization: PropTypes.string,
        }).isRequired,
        jobNumber: PropTypes.string,
        accountNumber: PropTypes.string,
        policyNumber: PropTypes.string,
        setDocumentCount: PropTypes.func,
        productCode: PropTypes.string,
        history: PropTypes.shape({
            push: PropTypes.func,
        }).isRequired,
        quoteDetailsData: PropTypes.func,
    };

    static defaultProps = {
        jobNumber: undefined,
        policyNumber: undefined,
        accountNumber: undefined,
        setDocumentCount: undefined,
        productCode: undefined,
        quoteDetailsData: undefined
    };

    state = {
        documentsData: [],
        isLoading: true,
    };

    componentDidMount() {
        this.getDocuments();
    }

    getCorrectNumber = () => {
        const { jobNumber, accountNumber, policyNumber } = this.props;
        return jobNumber || accountNumber || policyNumber;
    };

    getDocuments = async () => {
        const {
            authHeader,
            setDocumentCount,
            DocumentPageService,
            modalContext,
        } = this.props;

        this.setState({ isLoading: true });
        await DocumentPageService.getDocuments(
            this.getCorrectNumber(),
            authHeader
        )
            .then(availableDocumentsData => {
                this.setState({
                    documentsData: availableDocumentsData,
                });
                if (setDocumentCount) {
                    setDocumentCount(
                        availableDocumentsData.length,
                        DOCUMENTS_KEY
                    );
                }
            })
            .catch(() => {
                modalContext
                    .showAlert({
                        title: messages.modalError,
                        message: messages.errorLoadingDocument,
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: commonMessages.ok,
                    })
                    .catch(_.noop);
            })
            .finally(() => {
                this.setState({ isLoading: false });
            });
    };

    generateUploadToken = () => {
        const { DocumentPageService, authHeader, modalContext } = this.props;
        return DocumentPageService.generateUploadToken(authHeader).catch(() => {
            return modalContext
                .showAlert({
                    title: commonMessages.errorUploadTitle,
                    message: commonMessages.errorGenerateUploadToken,
                    status: 'error',
                    icon: 'mi-error-outline',
                    confirmButtonText: commonMessages.ok,
                })
                .catch(_.noop);
        });
    };

    uploadDocument = async file => {
        const {
            authHeader,
            jobNumber,
            accountNumber,
            policyNumber,
            DocumentPageService,
            modalContext,
        } = this.props;
        const documentMetaDataTemplate = {
            jobNumber: jobNumber,
            accountNumber: accountNumber,
            policyNumber: policyNumber,
            name: file.name,
            sessionID: await this.generateUploadToken(),
        };

        this.setState({ isLoading: true });
        await DocumentPageService.uploadDocument(
            file,
            documentMetaDataTemplate,
            authHeader
        )
            .then(documentUploadData => {
                if (!_.isEmpty(documentUploadData)) {
                    return this.getDocuments();
                }
                return null;
            })
            .catch(() => {
                modalContext
                    .showAlert({
                        title: commonMessages.errorUploadTitle,
                        message: commonMessages.uploadFailedMessage,
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: commonMessages.ok,
                    })
                    .catch(_.noop);
            })
            .finally(() => {
                this.setState({ isLoading: false });
            });
    };

    deleteDocument = async publicID => {
        const { authHeader, DocumentPageService, modalContext } = this.props;

        this.setState({ isLoading: true });
        await DocumentPageService.removeDocument(publicID, authHeader)
            .then(isDeleteItem => {
                if (isDeleteItem) {
                    this.getDocuments();
                }
            })
            .catch(() => {
                modalContext
                    .showAlert({
                        title: documentMessages.documentDeletionFailed,
                        message: documentMessages.documentCannotDeleted,
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: commonMessages.ok,
                    })
                    .catch(_.noop);
            })
            .finally(() => {
                this.setState({ isLoading: false });
            });
    };

    downloadDocument = (publicID, sessionID) => {
        const { DocumentPageService } = this.props;
        return DocumentPageService.downloadDocument(publicID, sessionID);
    };

    static contextType = TranslatorContext;

    render() {
        const { documentsData, isLoading } = this.state;
        const translator = this.context;
        const { jobNumber, policyNumber, productCode, quoteDetailsData, setDocumentCount, skipReviewActivity } = this.props;
        const productName = _.get(quoteDetailsData, 'loadQuoteSummary.productCode') || _.get(quoteDetailsData, 'loadRenewalSummary.productCode')
            || _.get(quoteDetailsData, 'loadPolicyChangeSummary.productCode') || _.get(quoteDetailsData, 'loadCancellationSummary.productCode');
        const uwCompany =_.get(quoteDetailsData, 'loadQuoteSummary.underwritingCompany_TWIA') ||
            _.get(quoteDetailsData, 'loadRenewalSummary.underwritingCompany_TWIA') || _.get(quoteDetailsData, 'loadPolicyChangeSummary.underwritingCompany_TWIA') ||
            _.get(quoteDetailsData, 'loadCancellationSummary.underwritingCompany_TWIA');
        const policyNo =_.get(quoteDetailsData, 'loadQuoteSummary.policy.policyNumber');
        const overrides = {
            documents: {
                initialDocumentsData: documentsData,
                uploadDocument: this.uploadDocument,
                deleteDocument: this.deleteDocument,
                isLoading: isLoading,
                downloadDocument: this.downloadDocument,
                noDataMessage: translator(messages.noPolicyChangeDocuments),
            },

            uploadDocumentsDetails: {
                jobNumber,
                policyNumber,
                productCode: productCode || productName,
                uwCompany,
                setDocumentCount,
                offerNumber: policyNo,
                skipReviewActivity
            },
        };
        const resolvers = {
            resolveComponentMap: {
                documentscomponent: DocumentComponent,
                documentUploadComponent: DocumentUploadComponent,
            },

        };
        return (
            <MetadataContent
                uiProps={metadata.pageContent}
                overrideProps={overrides}
                {...resolvers}
            />
        );
    }
}

export default withAuthenticationContext(
    withDependencies(['DocumentPageService'])(withModalContext(DocumentsPage))
);
